
export const isKorean = (text) => {
    if (!text) return false;
    const koreanChars = text.match(/[\uac00-\ud7af]/g);
    return koreanChars && koreanChars.length > 0;
};

export const isEnglish = (text) => {
    if (!text) return false;
    const englishChars = text.match(/[a-zA-Z]/g);
    return englishChars && englishChars.length > 0;
};
